import React from 'react';
import { Check } from 'lucide-react';

interface TimelineItemProps {
  step: number;
  title: string;
  description: string;
  isLast?: boolean;
}

const TimelineItem: React.FC<TimelineItemProps> = ({
  step,
  title,
  description,
  isLast = false,
}) => {
  return (
    <div className="flex">
      <div className="flex flex-col items-center mr-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-500 text-white font-bold">
          {step}
        </div>
        {!isLast && (
          <div className="w-1 bg-primary-200 h-full mt-2"></div>
        )}
      </div>
      
      <div className={`pb-8 ${isLast ? '' : 'mb-6'}`}>
        <h3 className="text-xl font-semibold text-primary-700 mb-2">
          {title}
        </h3>
        <p className="text-gray-600">
          {description}
        </p>
      </div>
    </div>
  );
};

interface TimelineProps {
  items: {
    step: number;
    title: string;
    description: string;
  }[];
}

const Timeline: React.FC<TimelineProps> = ({ items }) => {
  return (
    <div className="py-4">
      {items.map((item, index) => (
        <TimelineItem
          key={index}
          step={item.step}
          title={item.title}
          description={item.description}
          isLast={index === items.length - 1}
        />
      ))}
    </div>
  );
};

export default Timeline;